<template>
  <div>
    <b-button v-b-modal.modal-abertura-caixa
              class="w-100"
              size="lg">
      Abrir caixa
    </b-button>  
    <b-modal id="modal-abertura-caixa"
             centered
             title="Abertura de caixa"
             header-bg-variant="secondary"
             header-text-variant="white">
      <div v-if="saldo && saldo.pedidos">
        <label class="mr-1 saldo-text">Saldo atual: </label>
        <span class="saldo-text">{{ saldo.pedidos.saldoTotal | moneyToString }}</span>
      </div>
      <div v-else>
        <label class="mr-1 saldo-text">Saldo atual: </label>
        <span class="saldo-text">{{ 0 | moneyToString }}</span>
      </div>
      <template #modal-footer="{close}">
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="secondary"
                    class="mr-3 pl-4 pr-4 btn-voltar"
                    @click="close()">
            Voltar
          </b-button>
          <b-button class="pl-4 pr-4"
                    @click="abrirCaixa">
            Abrir Caixa
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  // Outros
  import { VMoney } from 'v-money'
  import {moneyToNumber} from '../../../../utils/conversors'
  import moment from 'moment'

  // Service
  import CaixaService from '../caixaService'

  export default {
    name: "TabelaFiltroTodos",
    directives: {
      money: VMoney
    },
    data () {
      return {
        saldoAnterior: 0,
        hoje: moment().format('YYYY-MM-DD'),
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        }
      }
    },
    computed: {
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      validaData () {
        if (this.cxData === moment().format('YYYY-MM-DD')) {
          return true
        }
        return false
      },
      saldo () {
        return this.$store.state.frenteCaixa.saldo
      },
    },
    watch: {
      'caixaStore.saldo_final' () {
        this.saldoAnterior = Number(this.caixaStore.saldo_final)
      }
    },
    async created  () {
      this.saldoAnterior = Number(this.caixaStore.saldo_final)
    },
    methods: {
      async abrirCaixa () {
        loader({active: true})
        try {          
          const novoCaixa = await CaixaService.abrirCaixa({saldoAnterior: this.saldoAnterior})
          this.$store.dispatch('frenteCaixa/atualizarCaixa', novoCaixa)
          this.$bvModal.hide('modal-abertura-caixa')
          displayMessage('success', 'success', 'Caixa aberto com sucesso')
        } catch (error) {
          const { message } = getErrors(error)
          displayMessage('error', 'Erro', message)
        } finally {
          loader({active: false})
        }  
      },
    }
  }
</script>

<style scope>
.saldo-text {
  font-size: 20px;
}
.btn-voltar {
  background-color: #C6C6C6;
  border-color: #C6C6C6;
  color: black
}
</style>